import { useSoundPath } from "hooks/useSoundPath";
import React from "react";

const CraftIdentityMatchesItemButton = ({ children, matchesRef, color, variables }) => {

  const playSound = useSoundPath();

  return (
    <button
      className="card-details__craft-item-button card-details__craft-item-button--identity"
      style={{
        "--data-color": color,
      }}
      onClick={(e) => {
        e.currentTarget.classList.toggle("active");
        matchesRef.current.update();
        if (!e.currentTarget.classList.contains('active')) {
          playSound('openSubmenu')
        } else {
          playSound('closeSubmenu')
        }
      }}
    >
      <span className="card-details__craft-item-name">{children}</span>
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9.16667 9.16667H10V13.3333M17.5 10C17.5 14.1421 14.1421 17.5 10 17.5C5.85786 17.5 2.5 14.1421 2.5 10C2.5 5.85786 5.85786 2.5 10 2.5C14.1421 2.5 17.5 5.85786 17.5 10Z"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="square"
        />
        <rect
          x="9.4335"
          y="6.1"
          width="1.13333"
          height="1.13333"
          fill={color}
          stroke={color}
          strokeWidth="0.3"
        />
      </svg>
      { variables.some((item) => item !== '') &&
        <span className="card-details__craft-item-variables">
          {
            variables.map((variable, index) => {
              if (variable !== '') {
                return <span className="card-details__craft-item-variables-item" key={index}>{variable}</span>
              } else return null
            })
          }
      </span>
      }
    </button>
  );
};

export default CraftIdentityMatchesItemButton;
